import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from "lodash";
import i18n from "../../../../i18next";

import { 
    loadDeliverySettings,
    loadAllTenderTypes,
    updateDeliverySettings,
    resetDeliverySettings,
    resetTenderTypes,
    getPaymentSettings } from '../../../../actions/index';
import ServiceSettings from './ServiceSettings';
import {getCurrencySymbol} from "../../../../utils/CommonUtils";
import { MENUU_ADMIN, MENUU_MASTER_ADMIN } from '../../../../utils/Constants';

class DeliveryScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            settingsData: []
        }

        this.updateDeliverySettings = this.updateDeliverySettings.bind(this);
    }

    componentDidMount() {
        const { role } = this.props.currentlyLoggedInUser;
        this.props.loadAllTenderTypes();
        const restaurantId = this.props.match.params.id;
        this.props.loadDeliverySettings(restaurantId);
        // Response and callback are used to prepopulate payment types
        if (role === MENUU_MASTER_ADMIN) {
            this.props.getPaymentSettings(restaurantId);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.deliverySettings !== prevProps.deliverySettings) {
            this.setState({
                settingsData: this.props.deliverySettings
            });
        }
    }

    componentWillUnmount() {
        this.props.resetDeliverySettings();
        this.props.resetTenderTypes();
    }

    updateDeliverySettings(settings, callback) {
        const restaurantId = this.props.match.params.id;
        let filteredPrepTimes = [];

        if (this.props.serviceSettingsGeneral.timeSlotBased) {
            settings.timeSlots = [...settings.preparationTimes];
            settings.preparationTimes = [];
        } else {
            settings.preparationTimes.map(prepTime => {
                let prepTimeCopy = {...prepTime};
                delete prepTimeCopy.maxOrders;
                delete prepTimeCopy.maxValue;
                delete prepTimeCopy.duration;

                filteredPrepTimes.push(prepTimeCopy);
            });

            settings.preparationTimes = filteredPrepTimes;
        }
        // Get deliveryZoneScreen based missing parameters from reducers and add them to settings
        settings.deliveryZones = _.cloneDeep(this.props.deliverySettings.deliveryZones);
        settings.zoneType = this.props.deliverySettings.zoneType;
        settings.sendFromDeliveryScreen = true;

        this.props.updateDeliverySettings(restaurantId, settings, callback);
    }

    render() {
        const deliveryTranslation = i18n.t('common:deliveryCollectionDineInCurbside.operationHoursDelivery');

        const currency = getCurrencySymbol(this.props.restaurant.currency);

        return (
            <ServiceSettings
                settings={this.props.deliverySettings}
                prepopulatedSettings={this.state.settingsData}
                updateSettings={this.updateDeliverySettings}
                tenderTypes={this.props.tenderTypes}
                hideOrderAmounts={true}
                translationPhrase={deliveryTranslation}
                currency={currency}
                timeSlotBased={this.props.serviceSettingsGeneral.timeSlotBased}
                showDeliveryProviderScreen={true}
            />
        );
    }
}

const mapStateToProps = (state) => {
    return {
        serviceSettingsGeneral: state.serviceSettingsGeneral,
        deliverySettings: state.deliverySettings,
        tenderTypes: state.tenderTypes,
        restaurant: state.restaurant,
        currentlyLoggedInUser: state.user
    }
};

export default connect(
    mapStateToProps, {
        loadDeliverySettings,
        loadAllTenderTypes,
        updateDeliverySettings,
        resetDeliverySettings,
        resetTenderTypes,
        getPaymentSettings
    })(DeliveryScreen);


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/service/DeliveryScreen.js